import { edmCampaign } from '@bingads-webui/edm-campaign';
import cacheManager from '@bingads-webui-campaign-legacy/cache-manager/index';
import contextManager from '@bingads-webui-static-legacy/summary/SummaryDataContextManager';

const getEdmName = name => `Model.${name}`;
const getEntityName = name => name.replace(/Model\./, '');

export default function () {
  cacheManager.subscribe({
    // Clear the context manager after invalidate
    afterInvalidate(cm, resource, isTriggeredFromOutside) {
      if (!isTriggeredFromOutside) {
        edmCampaign['odata.cache'].invalidateTypeCache(getEdmName(resource));
      }
    },
  });

  const { successEmitter } = contextManager;

  successEmitter.on('invalidate', (resource, skipEntityCallPaths = null) => {
    if (resource) {
      edmCampaign['odata.cache'].invalidateTypeCache(getEdmName(resource), null, '', skipEntityCallPaths);
    }
  });

  edmCampaign['odata.cache'].cacheEvent.subscribe({
    next: ({ type, entity }) => {
      if (type === 'invalidate') {
        cacheManager.invalidate(getEntityName(entity), true);
      }
    },
  });
}
